import {ArticleSelectionCard} from '@shared/Articles/ArticlePage/ArticleSelectionCard/ArticleSelectionCard';
import {SelectionHead} from '@shared/Articles/ArticlesWithSelectionsView/parts/SelectionHead/SelectionHead';

import {articleSelectionType} from '@strapi/types/ArticleMainInfo';

import styles from './TilesWithMain.module.scss';

type Props = {
  selection: articleSelectionType;
  handleArticleCardClick: (
    compilationName: string,
    article_name: string,
  ) => void;
  basePath: 'blog' | 'prostore';
};
export const TilesWithMain = ({
  selection,
  handleArticleCardClick,
  basePath,
}: Props) => {
  const {articles, title, allArticlesLink} = selection;
  if (!articles.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <SelectionHead title={title} link={allArticlesLink} />

      <div className={styles.tiles}>
        <div className={styles.mainTile}>
          <ArticleSelectionCard
            card={articles[0]}
            articleUrl={basePath}
            type="full"
            onArticleClick={() =>
              handleArticleCardClick(title, articles[0].cardTitle)
            }
          />
        </div>
        <div className={styles.secondaryTiles}>
          {articles.slice(1, 5).map((elem) => (
            <ArticleSelectionCard
              key={elem.id}
              card={elem}
              articleUrl={basePath}
              type="secondary"
              onArticleClick={() =>
                handleArticleCardClick(title, elem.cardTitle)
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};
